// /info/conference-file/:type type=report - resolution

export const URL_EXPORT_REPORT = 'info/conference-file/report';
export const URL_EXPORT_RESOLUTION = 'info/conference-file/resolution';